import React, { useState, useRef, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    Chip,
    ClickAwayListener,
    Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Stack,
    Typography
} from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';

// assets
import { IconLockSquare, IconLogout, IconSettings, IconSignature, IconUser } from '@tabler/icons';
import { appStore, EMPTY_USER } from '../../../../store/appStore';
import ChangePassword from '../../../../views/pages/authentication/auth-forms/ChangePassword';
import ChangeSignature from '../../../../views/pages/authentication/auth-forms/ChangeSignature';
import { isAdmin } from '../../../../libs/src/lib/service/userService';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const [selectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const [openChangePassword, setOpenChangePassword] = useState(false);
    const [openChangeSignature, setOpenChangeSignature] = useState(false);
    const MySwal = withReactContent(Swal);

    const navigate = useNavigate();
    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);

    const handleLogout = async () => {
        localStorage.setItem('outboxtek.logintoken', JSON.stringify({}));
        appStore.user = EMPTY_USER;
        navigate('/pages/login');
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <>
            <Chip
                sx={{
                    height: '48px',
                    alignItems: 'center',
                    borderRadius: '27px',
                    transition: 'all .2s ease-in-out',
                    borderColor: '#2a4084',
                    backgroundColor: 'white',
                    '& svg': {
                        stroke: '#2a4084'
                    },
                    '&[aria-controls="menu-list-grow"], &:hover': {
                        borderColor: '#2a4084',
                        background: '#2a4084!important',
                        color: theme.palette.primary.light,
                        '& svg': {
                            stroke: '#dcdcdc',
                            fill: '#2a4084'
                        }
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                icon={
                    <Avatar
                        src={IconUser.toString()}
                        sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px 0 8px 8px !important',
                            cursor: 'pointer',
                            border: 'solid 1px #2a4084',
                            backgroundColor: 'white',
                            '& svg': {
                                fill: '#2a4084',
                                stroke: '#2a4084'
                            }
                        }}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        color="inherit"
                    />
                }
                label={<IconSettings stroke={1.5} size="1.5rem" color={theme.palette.primary.main} />}
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
            />
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    {/*      <OutlinedInput
                                            sx={{ width: '100%', pr: 1, pl: 2, my: 2 }}
                                            id="input-search-profile"
                                            value={value}
                                            onChange={(e) => setValue(e.target.value)}
                                            placeholder="Search profile options"
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <IconSearch stroke={1.5} size="1rem" color={theme.palette.grey[500]} />
                                                </InputAdornment>
                                            }
                                            aria-describedby="search-helper-text"
                                            inputProps={{
                                                'aria-label': 'weight'
                                            }}
                                        />*/}

                                    <Box sx={{ p: 2 }}>
                                        <Stack style={{ margin: '16px 16px 28px 16px' }}>
                                            <Stack direction="row" spacing={0.5} alignItems="center">
                                                <Typography component={'span'} variant="h4">
                                                    {appStore.user.fullName ? appStore.user.fullName : 'Admin'}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                        <Divider />
                                        <List
                                            component="nav"
                                            sx={{
                                                width: '100%',
                                                maxWidth: 350,
                                                minWidth: 300,
                                                backgroundColor: theme.palette.background.paper,
                                                borderRadius: '10px',
                                                [theme.breakpoints.down('md')]: {
                                                    minWidth: '100%'
                                                },
                                                '& .MuiListItemButton-root': {
                                                    mt: 0.5
                                                }
                                            }}
                                        >
                                            {!isAdmin() && (
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 4}
                                                    onClick={() => {
                                                        setOpen(false);
                                                        setOpenChangeSignature(true);
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <IconSignature stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Typography component={'span'} variant="body2">
                                                                My signature
                                                            </Typography>
                                                        }
                                                    />
                                                </ListItemButton>
                                            )}
                                            <ListItemButton
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 4}
                                                onClick={() => {
                                                    setOpen(false);
                                                    setOpenChangePassword(true);
                                                }}
                                            >
                                                <ListItemIcon>
                                                    <IconLockSquare stroke={1.5} size="1.3rem" />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <Typography component={'span'} variant="body2">
                                                            Change Password
                                                        </Typography>
                                                    }
                                                />
                                            </ListItemButton>
                                            <ListItemButton
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 4}
                                                onClick={handleLogout}
                                            >
                                                <ListItemIcon>
                                                    <IconLogout stroke={1.5} size="1.3rem" />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <Typography component={'span'} variant="body2">
                                                            Logout
                                                        </Typography>
                                                    }
                                                />
                                            </ListItemButton>
                                        </List>
                                    </Box>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>
            <ChangePassword
                open={openChangePassword}
                onClose={() => setOpenChangePassword(false)}
                onSuccess={async () => {
                    await MySwal.fire({
                        titleText: 'Password changed!',
                        text: 'You will receive an email with the new password.',
                        icon: 'success',
                        timer: 4000,
                        showConfirmButton: false
                    });
                }}
            />
            <ChangeSignature open={openChangeSignature} onClose={() => setOpenChangeSignature(false)} />
        </>
    );
};

export default ProfileSection;
